module.exports = __webpack_public_path__ + "static/img/activity.47976540.png";